import { render, staticRenderFns } from "./ManualCard.vue?vue&type=template&id=4d907c20&scoped=true&"
import script from "./ManualCard.vue?vue&type=script&lang=js&"
export * from "./ManualCard.vue?vue&type=script&lang=js&"
import style0 from "./ManualCard.vue?vue&type=style&index=0&id=4d907c20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d907c20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardActions,VCardText,VHover,VListItem})
